import { connection } from '@/api/connection'

export default {
  getUserAccountStatement ({ customerId }) {
    return connection.get('instantor/statement', { params: { customerId } })
  }
}
